import { ApiShipmentType } from "entities/shared/shipmentCard.types";
import { parseTags } from "entities/shared/tags.parser";
import type { Tag, TagDTO } from "entities/shared/tags.types";
import { backofficeClient } from "shared/api/backofficeClient";

const TAGS_URL = "/api/shipment-tags";

type TagsResponseDTO = { tags?: TagDTO[] };

class TagsService {
  public getTags(): Promise<Tag[]> {
    return backofficeClient
      .get<TagsResponseDTO, TagsResponseDTO>(TAGS_URL, { params: { shipment_type: ApiShipmentType.AIR } })
      .then((response) => parseTags(response?.tags));
  }
}

const tagsService = new TagsService();

export { tagsService };
